<template>
  <ContentWrapper>
    <main id="main" class="main pt-32 pb-20 tablet-landscape:pb-24 laptop:pb-30">
      <div class="text-center text-2xl font-headings my-12 font-bold">
        Find a Partner
      </div>
      <div class="blocks space-y-20 tablet-landscape:space-y-24 laptop:space-y-30">
        <section class="section partners-block space-y-8 tablet-landscape:space-y-10 laptop:space-y-12">
          <div class="mx-auto w-full max-w-[calc(100vw-4rem)] tablet:max-w-[calc(100vw-6rem)] laptop:max-w-[67.5rem]">
            <FindAPartnerFilters v-if="!loading && !error" v-model:filters="filters" :partners="partners"
              @search="applyFilters" />
            <p v-else-if="loading" class="text-[15px] py-8 text-center text-gray-500">Loading partners…</p>
            <p v-else-if="error" class="text-[15px] py-8 text-center text-red-600">{{ error }}</p>
          </div>
          <div class="mx-auto w-full max-w-[calc(100vw-4rem)] tablet:max-w-[calc(100vw-6rem)] laptop:max-w-[67.5rem]">
            <div
              v-if="!loading && !error"
              class="grid grid-cols-1 md:grid-cols-3 gap-4">
              <PartnerCard v-for="partner in filteredPartners" :key="partner.name" :partner="partner" />
            </div>
          </div>
          <p v-if="!loading && !error && filteredPartners.length === 0" class="text-center text-gray-500 py-8">
            No partners match your search.
          </p>
        </section>
      </div>
    </main>
  </ContentWrapper>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import ContentWrapper from '../components/Layouts/ContentWrapper.vue'
import FindAPartnerFilters from '../components/FindAPartner/FindAPartnerFilters.vue'
import PartnerCard from '../components/FindAPartner/PartnerCard.vue'

const partners = ref([])
const loading = ref(true)
const error = ref(null)
const filters = ref({
  name: '',
  region: '',
  category: ''
})

const filteredPartners = computed(() => {
  let result = partners.value

  if (filters.value.name) {
    const q = filters.value.name.toLowerCase()
    result = result.filter(p => p.name?.toLowerCase().includes(q))
  }
  if (filters.value.region) {
    result = result.filter(p => (p.regions || []).includes(filters.value.region))
  }
  if (filters.value.category) {
    result = result.filter(p => (p.categories || []).includes(filters.value.category))
  }

  return result
})

onMounted(async () => {
  try {
    const response = await fetch('/partners.json')
    if (!response.ok) throw new Error('Failed to load partners')
    partners.value = await response.json()
  } catch (e) {
    error.value = e.message
  } finally {
    loading.value = false
  }
})

function applyFilters() {
  // Filters are applied reactively via filteredPartners computed
  // This emit handler could trigger a scroll to results if needed
}
</script>
